import { TranslationsContext } from '@teliaee/telia-translate';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Selector, Separator } from 'telia-front-react';
import InternetCalculatorStore from '../../stores/InternetCalculatorStore';
import { InternetCategory } from './InternetCalculatorInterfaces';

interface InternetCategoriesSelectorProps {
  partner: boolean;
  internetCategories: InternetCategory[];
  internetCalculatorStore?: InternetCalculatorStore;
}

@observer
class InternetCategoriesSelector extends React.Component<InternetCategoriesSelectorProps> {
  static contextType = TranslationsContext;
  declare context: React.ContextType<typeof TranslationsContext>;

  private get categorySelectorItems() {
    const translate = this.context.translate;
    const { internetCategories } = this.props;
    return internetCategories.map((category) => {
      return {
        name: 'internetCategories',
        id: category.id,
        value: category.id,
        label: translate(category.labelKey)
      };
    });
  }

  private onCategoryChanged = (value: string | string[]) => {
    const { partner, internetCategories, internetCalculatorStore } = this.props;
    const selectedCategoryValue = value instanceof Array ? value[0] : value;
    const selectedCategory = internetCategories.find((category) => category.id === selectedCategoryValue);

    internetCalculatorStore.selectCategory(selectedCategory, partner);
  };

  public render() {
    const translate = this.context.translate;
    const { partner, internetCategories, internetCalculatorStore } = this.props;

    if (internetCategories.length <= 1) {
      return null;
    }
    return (
      <>
        <Selector
          id={'internet-categories-selector'}
          items={this.categorySelectorItems}
          hideLabel={true}
          label={translate('internetAndTvCalculator.speedSelector')}
          inputType="radio"
          value={partner ? internetCalculatorStore.selectedPartnerCategoryId : internetCalculatorStore.selectedTeliaCategoryId}
          onChange={this.onCategoryChanged}
        />
        <Separator color={'invisible'} spacing={'small'} />
      </>
    );
  }
}

export default inject('internetCalculatorStore')(InternetCategoriesSelector);
